import api from '../utils/api';

const BUSINESS_ID = process.env.REACT_APP_BUSINESS_ID;

export const getEmployees = () => {
  return api.get(`/businesses/${BUSINESS_ID}/employees`);
};

export const getServiceEmployees = (serviceId) => {
  return api.get(`/businesses/${BUSINESS_ID}/services/${serviceId}/employees`);
};

export const getEmployeeDetail = (employeeId) => {
  return api.get(`/employees/${employeeId}`);
};
